import "aos/dist/aos.css"
import "bootstrap/dist/css/bootstrap.min.css"
import "react-alice-carousel/lib/alice-carousel.css"
import "@/styles/style.scss"

import AOS from "aos"

AOS.init({
  duration: 1000,
  offset: 100,
})
